import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import { ListItemText, Typography } from "@mui/material";
import { IPlanItem, setPlanItemToEdit } from "../store/modeleRapportSlice";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../util/apiClient";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../store";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Grid, Button } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';


export interface IAfficheContenuPlanProps {
  planRapport: IPlanItem[];
  setPlanRapport: any;
  currentModele: any;
  setMode: any;
  setPlanItem: any;
  handleSavePlan: any;
  loading: boolean;
  setDisableSaveButton: any;
  disableSaveButton: any;
}

const AfficheContenuPlan = (props: IAfficheContenuPlanProps) => {
  //props
  const {
    planRapport,
    setPlanRapport,
    currentModele,
    setMode,
    setPlanItem,
    handleSavePlan,
    loading,
    setDisableSaveButton,
    disableSaveButton
  } = props;

  //redux
  const dispatch = useDispatch();
  const { modelesRapport } = useSelector(
    (state: IReduxState) => state.modeleRapport
  );

  //Hooks
  const [selectedIndex, setSelectedIndex] = React.useState<number | null>(null);

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: any,
    item: IPlanItem
  ) => {
    setSelectedIndex(index);
    setPlanRapport(item);
  };

  const handleDeleteSectionPlan = async (indexSection: number) => {
    const newPlanNonOrdonne = planRapport.filter(
      (section) => section.index !== indexSection
    );

    if (newPlanNonOrdonne.length) {
      const newPlanOrdonne = newPlanNonOrdonne.map((item, i) => {
        return { ...item, index: i + 1 };
      });
      setPlanRapport(newPlanOrdonne);
    }
    setDisableSaveButton(false);
  };

  // const handleDeleteSectionPlan = async (indexSection: number) => {
  //   setPlanRapport(
  //     planRapport.filter((section) => section.index !== indexSection)
  //   );
  // };

  const handleClickOnEditIcon = (section: IPlanItem, index: number) => {
    setMode("edit");
    setPlanItem(section);
    setSelectedIndex(index);
  };


  const handleClickOnDuplicateIcon = (duplicateIndex: number) => {
    let newPlanRapport = [...planRapport];
    // Trouver l'index de l'objet à dupliquer dans le tableau
    const indexToDuplicate = newPlanRapport.findIndex(item => item.index === duplicateIndex);

    // Vérifier si l'objet avec l'index donné existe dans le tableau
    if (indexToDuplicate === -1) {
      console.error(`Aucun objet trouvé avec l'index ${duplicateIndex}`);
      return newPlanRapport;
    }

    // Dupliquer l'objet
    const duplicateObject = { ...newPlanRapport[indexToDuplicate]};
    // console.log("🚀 ~ handleClickOnDuplicateIcon ~ duplicateObject:", duplicateObject)

    // Insérer l'objet dupliqué juste après l'original
    newPlanRapport.splice(indexToDuplicate + 1, 0, duplicateObject);
    const debut = indexToDuplicate + 1
    //mise à jour des index
    if (newPlanRapport.length) {
      const arrayExtrait = newPlanRapport.splice(debut)
      let newPlanOrdonne = arrayExtrait.map((item) => {
        return { ...item, index: item.index + 1 };
      });
      // Réinsérer la partie modifiée dans le tableau original à partir de l'index 'debut'
      newPlanRapport.splice(debut, newPlanOrdonne.length, ...newPlanOrdonne);
      setPlanRapport(newPlanRapport);
    }
    return;
  }

  
  /**
   *  cette fonction permet de deplacer les sections du plan
   * @param result (draggableId, source, destination)
   * (draggableId:l'identifiant de la ligne à deplacer, , destination)
   * (source:la position de depart de la ligne à deplacer)
   * (destination:la position d'arriver de la ligne à deplacer)
   * @returns
   *
   */
  const onDragEnd = (result: any) => {
    const { draggableId, source, destination } = result;

    const parseIntdraggableId = parseInt(draggableId);

    //Ne rien executer si on deplace un item hors de la carde
    if (!destination) {
      return;
    }

    //Ne rien executer si l'on bouge un item et qu'on le remet à sa place
    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }

    //obtenir l'objet à repositionnner
    const sectionARepositionner: any = planRapport?.find(
      (section) => section.index === parseIntdraggableId
    );

    //remplacer les places dans le tableau
    let newPlanRapport = [...planRapport];
    newPlanRapport.splice(source.index, 1);
    newPlanRapport.splice(destination.index, 0, sectionARepositionner);

    //mettre à jour les index de chaque section du plan
    const planRapportOrdered = newPlanRapport.map((section: any, i: number) => {
      const newSection = { ...section, index: i + 1 };
      return newSection;
    });

    //mise à jour du state
    setPlanRapport(planRapportOrdered);
    setDisableSaveButton(false);
    return;
  };

  return (
    <div>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable" direction="vertical">
          {(provider: any) => (
            <div
              style={{
                background: "aliceblue",
                padding: 10,
                height: "75vh",
                overflow: "auto",
              }}
              ref={provider.innerRef}
              {...provider.droppableProps}
            >
              <Box sx={{ flexGrow: 1, width: "100%" }}>
                <List dense={true}>
                  {planRapport.length > 0 &&
                    planRapport.map((item, i: number) => {
                      const newIndex = item.index.toString();
                      return (
                        <div key={item.index}>
                          <Draggable draggableId={newIndex} index={i}>
                            {(provider: any, snapshot: any) => (
                              <div
                                ref={provider.innerRef}
                                {...provider.draggableProps}
                                {...provider.dragHandleProps}
                              >
                                <ListItem
                                  secondaryAction={
                                    <div style={{ display: "flex" }}>
                                      <IconButton
                                        onClick={() =>
                                          handleClickOnEditIcon(item, i)
                                        }
                                      >
                                        <ModeEditIcon fontSize="small" />
                                      </IconButton>
                                      <IconButton
                                        onClick={() =>
                                          handleClickOnDuplicateIcon(item.index)
                                        }
                                      >
                                        <ContentCopyIcon fontSize="small" />
                                      </IconButton>
                                      <IconButton
                                        onClick={() =>
                                          handleDeleteSectionPlan(item.index)
                                        }
                                      >
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    </div>
                                  }
                                >
                                  <ListItemButton
                                    selected={selectedIndex === i}
                                  // onClick={(event) => handleClickOnEditIcon(item)}
                                  >
                                    <ListItemText
                                      onClick={(event) => console.log("aaaaaa")}
                                      primary={
                                        <Typography
                                          variant="subtitle2"
                                          style={{
                                            fontSize: 10
                                          }}
                                        >
                                          {item.title}
                                          {/* {item.title?.toLocaleUpperCase()} */}
                                        </Typography>
                                      }
                                    // secondary={item.id}
                                    />
                                  </ListItemButton>
                                </ListItem>
                                <Divider />
                                {provider.placeholder}
                              </div>
                            )}
                          </Draggable>
                        </div>
                      );
                    })}
                </List>
              </Box>
              {provider.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
      >
        <Grid style={{ marginTop: 10 }}>
          <LoadingButton
            loadingPosition="end"
            loading={loading}
            endIcon={<SaveIcon />}
            size="small"
            variant="contained"
            onClick={handleSavePlan}
            disabled={disableSaveButton ? true : false}
          >
            Enregistrer
          </LoadingButton>

          {/* <Button
            size="small"
            variant="contained"
            onClick={handleSavePlan}
          >
            Enregistrer
          </Button> */}
        </Grid>
      </Grid>
    </div>
  );
};

export default AfficheContenuPlan;
